<template>
	<h-disclosure v-slot="{open}" :default-open="isOpen" as="section">
		<h2>
			<v-disclosure-button
				class="flex w-full items-center justify-between space-x-md py-md pr-md text-left font-bold hover:underline"
			>
				{{ title }}

				<v-icon v-if="open" icon="chevron-up" class="text-xl" />

				<v-icon v-else icon="chevron-down" class="text-xl" />
			</v-disclosure-button>
		</h2>

		<v-disclosure-panel
			static
			:unmount="false"
			class="pb-md transition duration-100 ease-out"
			:class="{
				'overflow-x-auto': scrollable,
				'hidden scale-95 opacity-0': !open,
			}"
		>
			<slot />
		</v-disclosure-panel>
	</h-disclosure>
</template>

<script lang="ts" setup>
defineProps<{
	title: string;
	scrollable?: boolean;
	isOpen?: boolean;
}>();
</script>
